module.exports = __webpack_public_path__ + "static/media/Mannequin_back.03a00120.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Services/Mannequin_back.jpg
// module id = 129
// module chunks = 0